import { WifiSlash } from '@phosphor-icons/react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNetworkStatus } from '@/hooks/useNetworkStatus';
import { useTranslation } from 'react-i18next';

export function OfflineBanner() {
  const { isOnline } = useNetworkStatus();
  const { t } = useTranslation();

  return (
    <AnimatePresence>
      {!isOnline && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="bg-destructive text-destructive-foreground overflow-hidden"
        >
          <div className="flex items-center justify-center gap-2 py-2 px-4 text-sm">
            <WifiSlash className="w-4 h-4" weight="bold" />
            <span>{t('errors.offline')}</span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
